import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Layout de rota que protege rotas administrativas.
 * Renderiza o Outlet (conteúdo filho) apenas se o usuário for admin.
 * Segue a arquitetura: Outlet é o pai do conteúdo, não o menu.
 */
const AdminLayout: React.FC = () => {
  const { isAdmin, isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        color: 'var(--text-muted, #888)'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            border: '3px solid rgba(37, 99, 235, 0.12)',
            borderTop: '3px solid var(--accent-primary, #2563eb)',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <span>Verificando permissões...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        color: 'var(--accent-danger, #ff4c4c)',
        textAlign: 'center'
      }}>
        <div>
          <h3>Acesso Negado</h3>
          <p>Você precisa estar logado para acessar esta área.</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        color: 'var(--accent-danger, #ff4c4c)',
        textAlign: 'center'
      }}>
        <div>
          <h3>Acesso Restrito</h3>
          <p>Apenas administradores podem acessar esta funcionalidade.</p>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default AdminLayout;
